import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCollectionDetail: builder.query({
            query: id => `/b2g/eco-admin/collection/${id}`,
            transformResponse: responseData => {
                if (responseData?.status === false) {
                    throw new Error(responseData?.statusCode)
                }
                return responseData?.data
            },
            providesTags: (result, error, arg) => {
                if (error || !result?.ids) {
                    return [{ type: 'B2gCollectionDetail', id: 'List' }, []];
                } else {
                    return result.ids.map(id => ({ type: 'B2gCollectionDetail', id }));
                }
            }
        }),
      
    })
})

export const {
    useGetCollectionDetailQuery,

} = extendedApiSlice